import { call, put } from 'redux-saga/effects'

import {
  fetchSpecialOffersCreatorFailure,
  fetchSpecialOffersCreatorSuccess
} from '../../actionCreators/specialOffersCreator/specialOffersActionCreators'

import { fetchApi } from '../helpers/fetchApi'

import Logger from '../../helpers/Logger'
import { isValidSku } from '../../helpers/skuValidator'

const logger = Logger.getInstance()

const endpoint = '/product-api/pdp-special-offers-service/partNumber'

const generateStructuredData = response => {
  const { data } = response

  const structuredData = {
    data: {
      attributes: data.attributes,
      promotionId: data.id,
      selectedProducts: []
    }
  }
  // If set has a minimum buy quantity, duplicate the set,
  // making sure the duplicates are not hosts.
  structuredData.data.attributes.productSets.forEach(set => {
    if (set.minimumBuyQuantity > 1) {
      const TARGET_QUANTITY = set.minimumBuyQuantity
      set.minimumBuyQuantity = 1
      let index = 1
      while (index < TARGET_QUANTITY) {
        const value = { ...set, host: false, sequenceId: structuredData.data.attributes.productSets.length + 1 }
        structuredData.data.attributes.productSets.push(value)
        index += 1
      }
    }
  })

  // If multiple sets are marked as host, only keep the first one containing the product as host.
  const hostSets = structuredData.data.attributes.productSets.filter(set => set.host)
  if (hostSets.length > 1) {
    const hostSet = hostSets.find(
      set => set.products.map(product => product.id).indexOf(structuredData.data.attributes.targetPartNumber) !== -1
    )
    structuredData.data.attributes.productSets.forEach(set => {
      set.host = set.sequenceId === hostSet.sequenceId
    })
  }

  // If every non host set has a length of 1, automatically select them
  const nonHostSets = structuredData.data.attributes.productSets.filter(set => !set.host)
  if (nonHostSets.length && nonHostSets.every(set => set.products.length === 1)) {
    nonHostSets.forEach(set => {
      structuredData.data.selectedProducts = [
        ...structuredData.data.selectedProducts,
        ...set.products.map(product => product.id)
      ]
    })
  }

  return structuredData
}

function* specialOffersCreatorSaga(action, baseUrl) {
  const {
    payload: { partNumber, promotionId }
  } = action
  const start = Date.now()

  try {
    if (!isValidSku(partNumber)) {
      const error = new Error('Invalid part number')
      error.status = 400

      throw error
    }
    const url = `${baseUrl || ''}${endpoint}/${partNumber}/promotionId/${promotionId}`
    const jsonData = yield call(fetchApi, url)
    const responseTime = Date.now() - start
    logger.debug('apiLogger', { params: action.payload, responseTime, jsonData }, 'pdp-special-offers-service read')
    jsonData.data = typeof jsonData === 'object' ? jsonData.data : JSON.parse(jsonData.text).data
    jsonData.data.attributes.targetPartNumber = partNumber

    const successAction = fetchSpecialOffersCreatorSuccess(generateStructuredData(jsonData))
    yield put(successAction)
  } catch (error) {
    const message = error.response && error.response.body && error.response.body.message
    const response = {
      errorDetail: message || error.toString(),
      errorCode: error.status || 500,
      data: {
        productId: partNumber,
        promotionId
      }
    }
    if (error.status === 404) {
      response.data.shortDescription = 'Product not found'
    } else if (error.status === 400) {
      response.data.shortDescription = 'Invalid part number'
    } else {
      response.data.shortDescription = 'An error occurred'
    }
    const responseTime = Date.now() - start
    logger.error(
      'apiLogger',
      { partNumber, promotionId, responseTime, errorDetail: message || error.toString(), error },
      'pdp-special-offers-service error'
    )
    const failureAction = fetchSpecialOffersCreatorFailure(response)
    yield put(failureAction)
  }
}

export { specialOffersCreatorSaga, endpoint, generateStructuredData }
